import * as helper from './../../../Assets/Js/helper';
import * as Events from './Events';

export default class DialogManager {
	constructor(buttonContainer, chatWindow, screenSize, clearChatOnEachStep, guestName) {
		this.buttonContainer = buttonContainer;
		this.chatWindow = chatWindow;
		this.clearChatOnEachStep = clearChatOnEachStep;
		this._guestName = guestName;
		this.runningTimeouts = [];
		this.screenSize = screenSize;
		this.currentButtons = '';
	}

	addButtons(buttons) {
		let stringifiedButtons = JSON.stringify(buttons.answer);

		if (stringifiedButtons !== this.currentButtons) {
			this.removeButtons();
			this.currentButtons = stringifiedButtons;

			let delay = buttons.hasOwnProperty('delay') ? parseInt(buttons.delay) : 0;

			for (let n = 0, len = buttons.answer.length; n < len; n++) {
				let oneButton = buttons.answer[n],
					text = oneButton.$,
					action = oneButton.action;

				if (text === '[end]') {
					if (action === 'callback: signup') {
						text = 'Jetzt anmelden!';
					} else {
						text = 'Jetzt live chatten!';
					}
				}

				if (text === '[start]') {
					text = 'Chat starten';
				}

				this.runningTimeouts.push(
					setTimeout(function () {
						this._showButton(text, action);
					}.bind(this), delay + 2000)
				);
			}
		}
	}

	reset() {
		this._clearTimeouts();
		this.removeButtons();
		this._clearChat(true);
	}

	_clearTimeouts() {
		for (let n = 0, nmax = this.runningTimeouts.length; n < nmax; n++) {
			clearTimeout(this.runningTimeouts[n]);
		}
		this.runningTimeouts = [];
	}

	_showButton(message, action) {
		let btn = helper.stringToHtml('<li class="answer"><div>' + message + '</div></li>');
		let appended = this.buttonContainer.appendChild(btn);

		helper.addEventListener(appended, 'click', function (evt) {
			evt.stopPropagation();
			if (action !== 'ex:chatEnd' && action !== 'callback: signup') {
				this._clearChat(false);
				this.removeButtons();
				this._showGuestMessage(message);
			}
			helper.triggerEvent(window, Events.NEXT_ACTION, {action: action});
		}.bind(this));

		if (this.screenSize === 'fullscreen') {
			helper.hide(document.getElementById('chat'));
		}
	}

	_showGuestMessage(message) {
		let newElement;

		if (this.clearChatOnEachStep) {
			let messages = document.querySelectorAll('li.message');
			for (let message of messages) {
				helper.remove(message);
			}
		}

		if (this.screenSize !== 'fullscreen') {
			newElement = helper.stringToHtml('<li class="message"><span class="ficker">' + this._guestName + '</span>' + message + '</li>');
			document.querySelector(this.chatWindow).appendChild(newElement);
		} else {
			newElement = helper.stringToHtml('<div id="guestChat" class="chat hidden"><span class="ficker">' + this._guestName + ' </span>' + message + '</div>');
			let guestChat = document.body.appendChild(newElement);
			helper.removeClass(guestChat, 'hidden');
			setTimeout(function () {
				helper.addClass(guestChat, 'hidden');
			}, 3000);
		}
	}

	_clearChat(force) {
		if (this.screenSize === 'fullscreen' || force === true) {
			let chats = document.querySelectorAll('div.chat');
			for (let chat of chats) {
				helper.remove(chat);
			}
		}
	}

	removeButtons() {
		this.buttonContainer.innerHTML = '';
	}
}
